import { render, staticRenderFns } from "./visit-apply.vue?vue&type=template&id=565d83ed&scoped=true&"
import script from "./visit-apply.vue?vue&type=script&lang=js&"
export * from "./visit-apply.vue?vue&type=script&lang=js&"
import style0 from "./visit-apply.vue?vue&type=style&index=0&id=565d83ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d83ed",
  null
  
)

export default component.exports